import { PROFILE_REQUEST, PROFILE_SHOW, PROFILE_FAIL, PROFILE_AGENCIES } from './../store/config';

const profileInit = {
	isFetching:false,
	edit:{},
	error:undefined,
	timestamp: undefined
};

const profile = (state = profileInit, action) => {
	switch(action.type) {
		case PROFILE_REQUEST:
			return {
				...state,
				isFetching: action.isFetching,
				timestamp: action.timestamp
			}
		case PROFILE_SHOW:
			return {
				...state,
				isFetching: action.isFetching,
				edit: action.payload,
				timestamp: action.timestamp,
			}
		case PROFILE_AGENCIES:
			return {
				...state,
				isFetching: action.isFetching,
				agencies: action.payload,
				timestamp: action.timestamp
			}
		case PROFILE_FAIL:
			return {
				...state,
				isFetching:action.isFetching,
				error:action.error,
				timestamp:action.timestamp
			}
		default:
			return {
				...state
			}
	}
};

export default profile;



// WEBPACK FOOTER //
// ./src/reducers/profile.js